import type { ReactNode } from "react";
import { ComponentScope } from "@/shared/ui/component-hierarchy/ComponentScope";
import { ModalContext } from "@/shared/ui/overlay/modal-context";
import { useModalPresenter } from "@/shared/ui/overlay/useModalPresenter";

export const ModalProvider: React.FunctionComponent<{
  children: ReactNode;
  fixedBodyScrollLock?: boolean;
}> = ({
  children,
  fixedBodyScrollLock = true,
}: {
  children: ReactNode;
  fixedBodyScrollLock?: boolean;
}) => {
  const presentation = useModalPresenter(fixedBodyScrollLock);
  return (
    <ComponentScope node={presentation.node}>
      <ModalContext.Provider value={presentation.value}>
        {children}
      </ModalContext.Provider>
    </ComponentScope>
  );
};
